module.exports = __webpack_public_path__ + "static/media/galleryImage01.e38b5cfa.jpg";